import React, { useCallback, useMemo, useState } from 'react';

import i18n from '@nextroll/ar-i18n';

import { ExpandablePanel } from './ExpandablePanel';


// hardcode for the alpha release; may be fetched from an API in the future
const ACCOUNT_BASED_ACTION_CONTACT_FILTER_LOCATIONS = {
    AK: 'Alaska',
    AL: 'Alabama',
    AR: 'Arkansas',
    AS: 'American Samoa',
    AZ: 'Arizona',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DC: 'District of Columbia',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    GU: 'Guam',
    HI: 'Hawaii',
    IA: 'Iowa',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    MA: 'Massachusetts',
    MD: 'Maryland',
    ME: 'Maine',
    MI: 'Michigan',
    MN: 'Minnesota',
    MO: 'Missouri',
    MP: 'Northern Mariana Islands',
    MS: 'Mississippi',
    MT: 'Montana',
    NC: 'North Carolina',
    ND: 'North Dakota',
    NE: 'Nebraska',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NV: 'Nevada',
    NY: 'New York',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    PR: 'Puerto Rico',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VA: 'Virginia',
    VI: 'U.S. Virgin Islands',
    VT: 'Vermont',
    WA: 'Washington',
    WI: 'Wisconsin',
    WV: 'West Virginia',
    WY: 'Wyoming'
};

export const ExpandablePanelLocationFilter = ({ filters, setFilters }: {
    filters: string[];
    setFilters: (filters: string[]) => void;
}) => {
    const [search, setSearch] = useState('');

    const filteredLocations = useMemo(() => Object.entries(ACCOUNT_BASED_ACTION_CONTACT_FILTER_LOCATIONS)
        .filter(([_, name]) => name.toLowerCase().includes(search.toLowerCase())), [search]);

    const handleCheck = useCallback((item: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            setFilters([...filters, item]);
            return;
        }
        setFilters([...filters].filter(i => i !== item));
    }, [filters, setFilters]);

    return (
        <ExpandablePanel
            title={i18n.gettext('Location')}
            icon={<i className='fas fa-map' />}
            items={filters}
            setItems={setFilters}
            className={{ body: 'workflow-node-panel-filter-location' }}
        >
            <input
                type='text'
                placeholder={i18n.gettext('Search')}
                value={search}
                onChange={e => setSearch(e.target.value)}
                className='form-control'
            />
            <i className='fas ar-icon-search' />
            <i role='button' className='fas fa-times' onClick={() => search && setSearch('')} />
            <br />
            {filteredLocations.map(([abbr, name]) => (
                <span key={`filter-location-checkbox-${abbr}`}>
                    <input
                        type='checkbox'
                        id={`filter-location-checkbox-${abbr}`}
                        name='filter-location-checkbox'
                        checked={filters.includes(abbr)}
                        onChange={handleCheck(abbr)}
                        className='ar-checkbox'
                    />
                    <label htmlFor={`filter-location-checkbox-${abbr}`}>
                        {name}
                    </label>
                </span>
            ))}
        </ExpandablePanel>
    );
};
